import "@hotwired/turbo-rails"
import "alpine-turbo-drive-adapter"
import Alpine from 'alpinejs'
import mask from "@alpinejs/mask"
import LocalTime from "local-time"
import "@rails/actiontext"
import "../controllers"
import "../src/timezone"
import "@37signals/lexxy"

LocalTime.start()

Alpine.plugin(mask)
window.Alpine = Alpine
Alpine.start()
